import { CaseCard } from './shared';

export function SocialMediaOverviewContent() {
  const cases = [
    {
      icon: '📱',
      title: '小红书自动化发文：完整操作指南',
      description:
        '使用 xiaohongshu-mcp + MCPorter 接入 OpenClaw，通过自然语言一键发布图文笔记、搜索内容、自动回复评论，实现小红书账号的 AI 全自动运营。',
      tags: ['小红书', 'xiaohongshu-mcp', 'MCPorter', 'AI 内容生成'],
      difficulty: 'intermediate' as const,
      link: '#',
    },
  ];

  return (
    <div className="space-y-10">
      {/* Header */}
      <div className="rounded-2xl border border-slate-700/60 bg-gradient-to-br from-slate-800/60 via-slate-900 to-slate-950 p-8">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-pink-500/10 border border-pink-500/30">
            <i className="ri-share-line text-pink-400 text-lg"></i>
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">社交媒体</h1>
            <p className="text-slate-400 text-sm mt-0.5">使用 OpenClaw 自动化管理各大社交平台内容与互动</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-4">
          {['小红书', '微博', '抖音', '内容运营', '自动发布', 'MCP 工具'].map((tag) => (
            <span
              key={tag}
              className="px-2.5 py-1 rounded-full bg-slate-700/60 text-slate-300 text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* 案例列表 */}
      <div>
        <h2 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-5">
          全部案例 · {cases.length} 篇
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cases.map((c, i) => (
            <CaseCard key={i} {...c} />
          ))}
        </div>
      </div>

      {/* Coming soon */}
      <div className="rounded-xl border border-dashed border-slate-700 p-8 text-center">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-slate-800 mx-auto mb-3">
          <i className="ri-add-line text-slate-400 text-xl"></i>
        </div>
        <p className="text-slate-400 text-sm">更多社交媒体案例正在整理中，敬请期待</p>
      </div>
    </div>
  );
}
